// extracted by css-extract-rspack-plugin
export default {"cls1":"MarketingCarousel-cls1_eoU","cls2":"MarketingCarousel-cls2_UqQ MarketingCarousel-cls1_eoU"};